import { KeywordSearchModelType, KeywordListModeType } from '../types';

export const keywordModalTextMap: { [key in KeywordSearchModelType]: string } =
  {
    extend: 'Extended Search',
    exact: 'Exact Search',
  };

export const keywordModeTextMap: { [key in KeywordListModeType]: string } = {
  include: 'Include',
  exclude: 'Exclude',
};
